import axios from "axios";

export const state = {
    vModel: [],
};

export const mutations = {};

export const getters = {
    // Whether the user is currently logged in.
};

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        //dispatch('validate')
    },
    getGridData({commit}, data) {
        
        // Fix the data structure issue
        const requestData = { ...data };
        delete requestData.url;
        
        return axios
            .post(data.url, requestData)
            .then((response) => {
                
                if (response?.data) {
                    return response.data?.data || response.data?.data?.data || response?.data;
                }
                return response;
            })
            .catch((error) => {
                console.error("getGridData - Error:", error);
                console.error("getGridData - Error response:", error.response);
                throw error;
            });
    },

    update({commit}, data) {
        console.log("commit", commit);
        return axios.put(data.url, data.payload);
    },
    add({commit}, data) {
        console.log("commit", commit);
        return axios.post(data.url, data.payload);
    },
    delete({commit}, data) {
        console.log("commit", commit);
        if (data.id) {
            return axios.delete(data.url + "?id=" + data.id);
        } else {
            return axios.delete(data.url);
        }
    },
    getById({commit}, data) {
        console.log("commit", commit);
        return axios.get(data.url + "?id=" + data.id);
    },
    list({commit}, url) {
        console.log("commit", commit);
        return axios.get(url);
    },
    get({commit}, url) {
        console.log("commit", commit);
        return axios.get(url);
    },
    post({commit}, request) {
        console.log("commit", commit);
        return axios.post(request.url, request.payload);
    },

    // updateInfo({commit},payload){
    //     console.log('payload',payload)
    //     if(payload.id)
    //     {
    //         LanguageService.updateLanguage(payload).then((response)=>
    //         {
    //             console.log('response',response)
    //         })
    //     }
    //     else{
    //         LanguageService.addLanguage(payload).then((response)=>
    //         {
    //             console.log('response',response)
    //         })

    //     }

    //     commit('SET_CURRENT_DATA',payload)
    // },
};

// ===
// Private helpers
// ===
